import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { CommonModule } from '@angular/common';
import { LoaderComponent } from '../../layout/loader/loader.component';
import { FormsModule } from '@angular/forms';
import { ModalHeaderComponent } from '../../modals/modal-header/modal-header.component';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-license-form',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    LoaderComponent,
    ModalHeaderComponent
  ],
  templateUrl: './license-form.component.html',
  styleUrl: './license-form.component.scss'
})
export class LicenseFormComponent implements OnInit {
  @Input() userId: string = '';
  @Input() organisationId: string = '';
  @Input() reload: boolean = false;
  @Input() item: any = {};

  modalTitle: string = 'Licentie toevoegen';
  modalStyle: boolean = false;

  errorMessage: string = '';
  loading: boolean = false;

  licenseList: any[] = [];
  periodsList: any[] = [];
  filteredLicenses: any[] = [];
  selectedPeriod: string = '';

  constructor(private apiService: ApiService, private activeModal: NgbActiveModal) { }

  ngOnInit(): void {
    this.getPeriods();
    this.getLicenses();

    this.item['activated_at'] = this.formatDate(new Date());
  }

  formatDate(date: Date): string {
    const year = date.getFullYear();
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const day = ('0' + date.getDate()).slice(-2);
    return `${year}-${month}-${day}`;
  }

  getPeriods() {
    this.loading = true;
    this.apiService.get('/office/periods').then((response: any) => {
      this.periodsList = response.data;
      this.loading = false;
    }).catch(error => {
      this.loading = false;
      this.errorMessage = 'Error fetching periods';
    });
  }

  getLicenses() {
    this.loading = true;
    this.apiService.get('/office/licenses').then((response: any) => {
      this.licenseList = response.data;
      this.filteredLicenses = this.licenseList;
      this.loading = false;
    }).catch(error => {
      this.loading = false;
      this.errorMessage = 'Error fetching licenses';
    });
  }

  filterLicenses() {
    if (this.selectedPeriod) {
      this.filteredLicenses = this.licenseList.filter(
        license => license.period.id === this.selectedPeriod
      );
    } else {
      this.filteredLicenses = this.licenseList;
    }
  }

  addSelectedLicenses() {
    const selectedLicenses = this.filteredLicenses
      .filter(license => license.selected)
      .map(license => ({
        user_id: this.userId,
        license_id: license.id,
        organisation_id: this.organisationId,
        activated_at: this.item.activated_at,
        active: 1
      }));

    if (selectedLicenses.length === 0) {
      this.errorMessage = 'Selecteer ten minste één licentie';
      return;
    }

    this.loading = true;
    Promise.all(
      selectedLicenses.map((license: any) => {
        this.apiService.post('/office/user-licenses', license)
      }
      )
    )
      .then(() => {
        this.loading = false;
        this.activeModal.close(true);
      })
      .catch(() => {
        this.loading = false;
        this.errorMessage = 'Fout bij het toevoegen van licenties';
      });
  }
}

